export const API_PATH = process.env.REACT_APP_API_PATH;

export const KEYCLOAK_CONFIG = process.env.REACT_APP_KEYCLOAK_CONFIG;